<div class="app-loader-dialog text-center">
    <h6 class="app-loader-title m-0 !p-4" *ngIf="!!title">{{ title }}</h6>
    <div mat-dialog-content class="app-loader-content">
        <div
            class="app-loader-spinner"
            role="progressbar"
            aria-label="Loading"
            aria-valuetext="Loading"
        ></div>
    </div>
</div>
